import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth/auth.service';

export const EMAILS_ESTADISTICAS_AVANZADAS: string[] = [
    'ramossistemas@gmail.com',
    'secretariaprivada@uoetsylra.org',
    'vaninaarce@uoetsylra.org',
    'naumannthostrupivan@gmail.com',
];

export function puedeAccederEstadisticasAvanzadas(email: string | null): boolean {
    if (!email) {
        return false;
    }
    const emailNormalizado = email.toLowerCase();
    return EMAILS_ESTADISTICAS_AVANZADAS.some(
        (e) => e.toLowerCase() === emailNormalizado,
    );
}

@Injectable({
    providedIn: 'root'
})
export class EstadisticasAvanzadasGuard implements CanActivate {

    constructor(
        private authService: AuthService,
        private router: Router,
    ) { }

    async canActivate(): Promise<boolean | UrlTree> {
        const email = await this.authService.getEmail();
        if (puedeAccederEstadisticasAvanzadas(email)) {
            return true;
        }
        return this.router.createUrlTree(['/estadisticas-sistema']);
    }
}
